<template>
  <BittsCollapse
    v-model:is-open="isOpen"
    chevron-placement="right"
    :toggle-on-body-click="false"
    class="c-record-exports-learn-more"
  >
    <template #title>
      <div class="flex items justify-between w-full">
        <h6 class="text-info-text text-base/6 font-bold">
          Learn more about record exports
        </h6>
        <p class="text-neutral-text-weak text-base/6 font-normal mr-8">{{
          isOpen ? 'Collapse' : 'Expand'
        }}</p>
      </div>
    </template>
    <div class="flex flex-wrap lg:flex-nowrap gap-24 items-start pt-16">
      <LearnMoreCard
        class="w-full lg:max-w-[50%]"
        :card="{
          caption: '2 minutes',
          title: 'Record Export Limits',
          description:
            'Better understand what record exports are and how your limit is affected',
          resource: 'Article',
          link: 'https://help.crossbeam.com/en/articles/8399864-record-export-limits',
        }"
      />
      <LearnMoreCard
        class="w-full lg:max-w-[50%]"
        :card="{
          caption: '10 minutes',
          title: 'Maximizing Value from Record Exports',
          description:
            'Explore record exports, their limits, and overall strategies to use them smarter',
          resource: 'Academy',
          link: 'https://academy.crossbeam.com/maximizing-value-from-record-exports',
        }"
      />
    </div>
  </BittsCollapse>
</template>

<script setup lang="ts">
import { BittsCollapse } from '@crossbeam/bitts';

import { ref } from 'vue';

import LearnMoreCard from '@/components/onboarding/LearnMoreCard.vue';

const isOpen = ref(false);
</script>

<style scoped lang="pcss">
@reference "../../css/theme.css";
:deep(.learn-more-card) {
  .learn-more-card__header {
    @apply mb-16!;
  }

  h4 {
    @apply text-base mb-0!;
  }

  p {
    @apply text-base mb-16!;
  }

  a {
    @apply text-base;
  }
}

.c-record-exports-learn-more {
  @apply px-24 py-16 bg-neutral-background-weak rounded-lg;
}
</style>
